export default "__VITE_ASSET__Chnde89g__"